import axios from 'axios';
import store from '../store';

// No baseURL: every endpoint constant (URL_AUTH, URL_USERS, …) already includes
// the full `${URL}/...` path. Setting baseURL to URL too would double the prefix
// (e.g. /api/v1/api/v1/auth) now that URL is a relative path.
const apiClient = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    const selectedCustomer = store.getState().customers.selectedCustomer;
    const user = store.getState().auth.user;
    const role = user?.role;
    const accessToken = user?.accessToken;

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      if (role === 'admin' && selectedCustomer) {
        config.headers['X-Custom-Field'] = selectedCustomer;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (!error.response) {
      console.error('Network Error:', error);
    }
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Reusable Functions
export const getData = async (endpoint, queryParams = {}) => {
  try {
    return await apiClient.get(endpoint, { params: queryParams });
  } catch (error) {
    console.error('API GET failed:', error);
    throw error;
  }
};

export const postData = async (endpoint, data, headers = {}) => {
  try {
    return await apiClient.post(endpoint, data, { headers });
  } catch (error) {
    console.error('API POST failed:', error);
    throw error;
  }
};

export const patchData = async (endpoint, data) => {
  try {
    return await apiClient.patch(endpoint, data);
  } catch (error) {
    console.error('API PATCH failed:', error);
    throw error;
  }
};

// putData.js
export const putData = async (endpoint, data, config = {}) => {
  try {
    return await apiClient.put(endpoint, data, {
      ...config,
      params: {
        ...config.params,
      },
    });
  } catch (error) {
    console.error('API PUT failed:', error);
    throw error;
  }
};



export const deleteData = async (endpoint) => {
  try {
    return await apiClient.delete(endpoint);
  } catch (error) {
    console.error('API DELETE failed:', error);
    throw error;
  }
};

// Unified Function for Images (Multipart/FormData)
export const postImage = async (endpoint, formData) => {
  try {
    return await postData(endpoint, formData, {
      'Content-Type': 'multipart/form-data',
    });
  } catch (error) {
    console.error('API Image POST failed:', error);
    throw error;
  }
};
